module.exports = __webpack_public_path__ + "img/reward_4.7a5ac7b2.png";